import { HistoryOptions, Module } from 'history';
import createHistory from 'history/lib/createBrowserHistory';
import useBasename from 'history/lib/useBasename';
import * as React from 'react';
import { Provider } from 'react-redux';
import { IndexRedirect, IndexRoute, Route } from 'react-router';
import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
  GenericStoreEnhancer,
  ReducersMapObject
} from 'redux';
import {
  reduxReactRouter,
  ReduxRouter,
  routerStateReducer
} from 'redux-router';
import thunkMiddleware from 'redux-thunk';
import App from './layout-components/App';
import ProductWrapper from './layout-components/ProductWrapper';
import AddressPage from './page-components/AddressPage';
import CheckCode from './page-components/CheckCode';
import Components from './page-components/Components';
import GotoSpid from './page-components/GotoSpid';
import PlaceOrder from './page-components/PlaceOrder';
import Product from './page-components/Product';
import ProductQuarantined from './page-components/ProductQuarantined';
import ReceiptPage from './page-components/ReceiptPage';
import SelectPaymentMethod from './page-components/SelectPaymentMethod';
import StartPage from './page-components/Start';
import UserInfo from './page-components/UserInfo';
import UserInfoLandingPage from './page-components/UserInfoLandingPage';
import UserSearch from './page-components/UserSearch';
import WaitForEmail from './page-components/WaitForEmail';
import * as reducers from './reducers';
import AcceptAgreement from './page-components/AcceptAgreement';
import CompanyPaysPage from './page-components/CompanyPaysPage';

const windowAsAny: any = window;
const devToolsExtension: GenericStoreEnhancer = windowAsAny.devToolsExtension
  ? windowAsAny.devToolsExtension()
  : (f: any) => f;
const basePath = (window.location.pathname.match(/.*\/ff\//) || ['/'])[0];
const store = compose(
  reduxReactRouter({
    createHistory: () =>
      useBasename(createHistory)({
        basename: basePath
      } as HistoryOptions)
  } as Module) as GenericStoreEnhancer,
  applyMiddleware(thunkMiddleware),
  devToolsExtension
)(createStore)(
  combineReducers({
    ...reducers,
    router: routerStateReducer
  } as ReducersMapObject)
);

export default (
  <Provider store={store}>
    <ReduxRouter>
      <Route component={App} path="/">
        <IndexRedirect to="/products/1141" />
        <Route path="/products/:productId" component={ProductWrapper}>
          <IndexRoute component={Product} />
          <Route path="start" component={StartPage} />
          <Route path="selectpaymentmethod" component={SelectPaymentMethod} />
          <Route
            path="selectpaymentmethod/:paymentMethodId"
            component={SelectPaymentMethod}
          />
          <Route path="usersearch" component={UserSearch} />
          <Route path="checkcode" component={CheckCode} />
          <Route path="userinfo" component={UserInfo} />
          <Route path="address" component={AddressPage} />
          <Route path="waitForEmail" component={WaitForEmail} />
          <Route path="userinfolandingpage" component={UserInfoLandingPage} />
          <Route path="placeorder" component={PlaceOrder} />
          <Route path="productquarantined" component={ProductQuarantined} />
          <Route path="components" component={Components} />
          <Route path="receipt" component={ReceiptPage} />
          <Route path="gotospid" component={GotoSpid} />
          <Route path="acceptagreement" component={AcceptAgreement} />
          <Route path="companypays" component={CompanyPaysPage} />
        </Route>
      </Route>
    </ReduxRouter>
  </Provider>
);



// WEBPACK FOOTER //
// ./src/routes.tsx